import { NationalNumber } from 'libphonenumber-js/min'
import { filter, find } from 'lodash'
import React from 'react'
import { DEFAULT_COUNTRY_CALLING_CODE } from '../../../constants'
import { countries, BaseEnum, nationalities } from '@klarpay/enums'

export type BaseEnumWithKey = BaseEnum & { key: string }

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export const validCountries = () => {
  return filter(countries, (country) => !country.forbidden)
  // return filter(countries, (country) => country.forbidden === true)
}

export const countriesList = validCountries()

// is valid countries key for validation
export const validCountriesKeyList = countriesList.map((country) => country.key) as string[]

// export const countriesArray = Object.values<ICountryEnum>(countriesList)
export const countriesArray = Object.values<BaseEnumWithKey>(countries).sort(
  (a, b) => -b.label.localeCompare(a.label),
)

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export const prefixCode = (phoneCountryCode = DEFAULT_COUNTRY_CALLING_CODE) => {
  const countryCode =
    find(countries, (c) => c.value.toLowerCase() === phoneCountryCode?.toLowerCase())
      ?.callingCode || ''
  return `+${countryCode}`
}

export type Countries = typeof countries

export const nationalitiesArray = Object.values(nationalities).sort(
  (a, b) => -b.label.localeCompare(a.label),
)

export type NetworkNameType = 'mainnet' | 'sepolia'

export type MenuListCompositionProps = {
  countryCode: string | undefined
  error: boolean
  countryKey: string | undefined
  setCountryKey: React.Dispatch<React.SetStateAction<string | undefined>>
  value: string | NationalNumber
  name: string
  componentDisabled?: boolean
}
